import { apiRequest } from './client';

export function fetchPreferences(token) {
  return apiRequest('/admin/preferences', token);
}

export function saveThemePreference(token, theme) {
  return apiRequest('/admin/preferences', token, {
    method: 'PUT',
    body: JSON.stringify({ theme }),
  });
}
